import { useCallback, useEffect } from 'react';

export const useResize = props => {
  const onResize = useCallback(() => {
    if (props.isTutorialOn) props.updateTutorial();
  }, [props.isTutorialOn]);

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
};
